import React, { useRef } from 'react';

import { useReactToPrint } from 'react-to-print';

import { ImPrinter } from 'react-icons/im';
import { BsCheckCircle } from 'react-icons/bs';

import { PrinterButton } from './styles';

import ComponentToPrintReport from './ComponentToPrint';

import { Data } from '../../pages/Historico/OrderTable';

interface PrinterProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  pedidos: Data[];
  label?: string;
  backgroundColor: string;
  textColor: string;
}

const PrinterReport: React.FC<PrinterProps> = ({
  pedidos,
  label,
  backgroundColor,
  textColor,
  onClick,
  ...rest
}) => {
  const inputEl = useRef(null);

  const handlePrint = useReactToPrint({
    content: () => inputEl.current,
    pageStyle: `
      @page {
        margin: 12mm 5mm;
      }
    `
  });

  return (
    <>
      <div style={{ display: 'none' }}>
        <ComponentToPrintReport ref={inputEl} pedidos={pedidos} />
      </div>

      <PrinterButton
        backgroundColor={backgroundColor}
        textColor={textColor}
        onClick={(params) => {
          onClick && onClick(params);
          handlePrint && handlePrint();
        }}
        {...rest}
      >
        {label ? <BsCheckCircle size={20} /> : <ImPrinter size={20} />}
        {label}
      </PrinterButton>
    </>
  );
};

export default PrinterReport;
